export const carouselExtensionType = 'com.atlassian.confluence.carousel';
